// Module
var code = `<div class="js-buttons-popup" style="{{>position}}">
    {{#each popupItems: i}}
        <terceraButton name="{{popupItems[i].name}}"
                       tooltip="{{popupItems[i].tooltip}}"
                       checked="{{popupItems[i].active}}"
                       enabled="{{popupItems[i].enabled}}"
                       visible="{{popupItems[i].visible}}"
                       SVG="true"
                       canCheck="true"
                       on-btnClick="@this.onItemClicked(this)"
                       terceraButtonStyle="js-chart-tool-button" />
    {{/each}}
</div>`;
// Exports
export default code;